import type { SerializedStyles } from '@emotion/react';

import gql from 'graphql-tag';
import { compose } from 'recompose';

import idvVendorGql from 'js/lib/idvVendorGql';
import user from 'js/lib/user';
import waitForGraphQL from 'js/lib/waitForGraphQL';

import type { ButtonProps } from '@coursera/cds-core';

import type { IdVerificationVendorStatus_IdVerificationVendorIntegration_latestByMe as VerificationStatus } from 'bundles/verification/api/__generated__/IdVerificationVendorStatus';

export type UserVerificationData = {
  firstName: string;
  middleName: string;
  lastName: string;
  verifiedBy: string;
  jumioIdVerificationAttemptHistory: {
    failedAttemptCount: number;
  };
};

type InputProps = {
  showCTAonRight?: boolean;
  openInNewTab?: boolean;
  buttonVariant?: ButtonProps['variant'];
  customStyles?: SerializedStyles;
};

export type Props = InputProps & {
  additionalQueryParams: { [key: string]: string | boolean };
  userVerificationInformation: UserVerificationData;
  verificationRequirements: string;
  latestVerificationStatus: VerificationStatus;
  refetchVerificationStatus: () => void;
};

export default compose<Props, InputProps>(
  waitForGraphQL(
    gql`
      query GetUserVerificationRequirements($ids: [String!]!) {
        UserVerificationRequirementsV1Resource {
          multiGet(ids: $ids) {
            elements {
              id
              userVerificationRequirementState
            }
          }
        }
      }
    `,
    {
      props: ({
        data: {
          // @ts-expect-error TSMIGRATION
          UserVerificationRequirementsV1Resource,
        },
      }) => ({
        verificationRequirements:
          UserVerificationRequirementsV1Resource?.multiGet?.elements?.[0]?.userVerificationRequirementState,
      }),
      options: () => {
        return {
          variables: {
            ids: [user.get().id.toString()],
          },
        };
      },
    }
  ),
  waitForGraphQL(
    gql`
      query GetIdVerificationHistory {
        IdVerificationsV1Resource {
          me {
            elements {
              id
              firstName
              middleName
              lastName
              verifiedBy
              jumioIdVerificationAttemptHistory {
                failedAttemptCount
              }
            }
          }
        }
      }
    `,
    {
      props: ({
        data: {
          // @ts-expect-error TSMIGRATION
          IdVerificationsV1Resource: {
            me: { elements },
          },
        },
      }) => ({
        userVerificationInformation: elements[0] || { verifiedBy: 'NONE' },
      }),
    }
  ),
  waitForGraphQL(
    idvVendorGql`
      query GetIdVerificationVendorStatus {
        IdVerificationVendorIntegration {
          latestByMe {
              verificationId
              verificationStatus
          }
        }
      }
`,
    {
      options: { context: { clientName: 'gatewayGql' } },
      props: ({ data }: $TSFixMe) => {
        return {
          latestVerificationStatus: data?.IdVerificationVendorIntegration?.latestByMe,
          refetchVerificationStatus: data.refetch,
        };
      },
    }
  )
);
